/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  SearchSessionsMutationRequest,
  SearchSessionsMutationResponse,
  SearchSessions401,
  SearchSessions403,
} from '../types/SearchSessions.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getSearchSessionsUrl() {
  const res = { method: 'POST', url: `/sessions/search` as const };
  return res;
}

/**
 * @summary Search sessions
 * {@link /sessions/search}
 */
export async function searchSessions(
  data: SearchSessionsMutationRequest,
  config: Partial<RequestConfig<SearchSessionsMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    SearchSessionsMutationResponse,
    ResponseErrorConfig<SearchSessions401 | SearchSessions403>,
    SearchSessionsMutationRequest
  >({ method: 'POST', url: getSearchSessionsUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
